import React from 'react'
import PropTypes from 'prop-types'

import { digObject } from 'functions/utilities'

import VimeoPlayer from 'components/VimeoPlayer'
import YouTubePlayer from 'components/YouTubePlayer'

const getVideoSettings = (dataSource, customVideo) => {
  if (customVideo && customVideo.id){
    return {
      id: customVideo.id,
      provider: customVideo.provider,
    }
  }

  const videoId = digObject(dataSource, 'options.video_id')
  const videoProvider = digObject(dataSource, 'options.video_provider')

  if (videoId && videoProvider){
    return {
      id: videoId,
      provider: videoProvider,
    }
  }

  return {}
}

const VideoPlayer = (props) => {
  const { dataSource, customVideo } = props

  const settings = getVideoSettings(dataSource, customVideo)

  if (settings.provider === 'vimeo'){
    return <VimeoPlayer width="100%" height="100%" videoId={settings.id} />
  }

  if (settings.provider === 'youtube'){
    return <YouTubePlayer width="100%" height="100%" videoId={settings.id} />
  }

  return null
}

VideoPlayer.propTypes = {
  dataSource: PropTypes.object,
  customVideo: PropTypes.object,
}

export default VideoPlayer
